module.exports = __webpack_public_path__ + "static/scale-model-of-toledo-zoo-in-toledo-ohio-ba6f7f6329a7d7f2017063b613efd8fc.png";